/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type YmmeDropdownData } from '../interface';

export const findListItemByLabel = (
  ymmeData: YmmeDropdownData = [],
  label: string | null = '',
  index?: number
) => {
  const results = ymmeData
    .map((ymmeListItem, listIndex) => {
      if (ymmeListItem.label === label) {
        if (!!index && listIndex === index) {
          return { ...ymmeListItem, index };
        } else if (!index) {
          return ymmeListItem;
        }
      }
      return undefined;
    })
    .filter((ymmeListItem) => !!ymmeListItem)[0];
  return results;
};
